import * as React from 'react';
import * as Glob from '../Globale';
import * as Compat from '../Compat';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad, CampoCheckBox } from '../components/';
import { Dictionary } from '../Dati';


interface IInputCheckBoxProps extends Dati.IBaseProps {
    Etichetta: string;
    Valore: boolean;
    Righe?: number;
}

export class InputCheckBox extends BasePureComponent<IInputCheckBoxProps, {}> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        return <div style={{ minHeight: 35 }} className={this.props.CSS != undefined ? this.props.CSS : ""}>
            <CampoCheckBox
                Id={this.props.Id}
                Name={this.props.Name}
                Valore={this.props.Valore}
                Etichetta={this.props.Etichetta}
                OnChange={this.props.OnChange} />
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/InputCheckBox.tsx